import React, { Suspense, lazy, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { getIsLoggedIn } from '../publicSession/selectors';
import { useIsMounted } from '../utils/hooks/useIsMounted';
import ErrorBoundary from '../ErrorBoundary';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import retry from '../utils/webpack/chunkRetry';
var LoadableInit = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "chat" */
        './ChatInitLoadable');
    });
});
var LoadableChatBar = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "chat" */
        './ChatBar');
    });
});
/**
 * ChatInit checks if chat is enabled for this context and then starts
 * up the connection to wix chat. The chat chunk contains the wix SDK and
 * the redux reducers/sagas. UI is in separate chunks and uses redux actions
 * to perform all SDK actions.
 */
export var ChatInit = function (_a) {
    var disableFloatingChat = _a.disableFloatingChat;
    var isChatDisabled = useFlag('adbrain');
    var isLoggedIn = useSelector(getIsLoggedIn);
    var isMounted = useIsMounted();
    var isMobile = useContext(MobileContext);
    if (!isLoggedIn || !isMounted || isChatDisabled) {
        return null;
    }
    // prevent chat inside iframes
    if (typeof window !== 'undefined' && window.top !== window.self) {
        return null;
    }
    return (React.createElement(ErrorBoundary, null,
        React.createElement(Suspense, { fallback: null },
            React.createElement(LoadableInit, null),
            !isMobile && !disableFloatingChat && React.createElement(LoadableChatBar, null))));
};
ChatInit.displayName = 'ChatInit';
export default ChatInit;
//# sourceMappingURL=ChatInit.js.map